import { createLucideIcon } from "lucide-react";

export const MultiplicationCircle = createLucideIcon(
    "MultiplicationCircle",
    [
        [
            "path",
            {
                d: "M12 12L15.5 15.5",
                key: "12kf97",
            },
        ],
        [
            "path",
            {
                d: "M12 12L8.5 15.5",
                key: "qt66hz",
            },
        ],
        [
            "path",
            {
                d: "M12 12L8.5 8.5",
                key: "con7y3",
            },
        ],
        [
            "path",
            {
                d: "M15.5 8.5L12 12",
                key: "1ctvzk",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
